import React from 'react';
import Loader from "./Loader";
import CustomButton from "./CustomButton";
import { useState } from "react";
import ErrorBox from "./ErrorBox";
import CustomInput from "./CustomInput";
import Modal from "./Modal";
import {createKassa, getAllKassas} from "../services/kassa/kassaServices";
import saveIcon from "../assets/save_icon.png";
import closeIcon from "../assets/close_icon.png";
import { useTranslation } from "react-i18next";
import {useNavigate} from "react-router-dom";



function AddKassaModal({ setShowKassaModal }) {


    const { t } = useTranslation("general");

    const [kassaName, setKassaName] = useState("");
    const [loadingModal, setLoadingModal] = useState(false);
    const [error, setError] = useState("");

    const navigate = useNavigate();




    const handleCancel = () => {
        setShowKassaModal(false);
        setKassaName("");
        setError("");
    };

    const handleCreateKassa = async () => {
        if (!kassaName.trim()) {
            setError("noKassaName");
            return;
        }

        setLoadingModal(true);
        setError("");

        try {
            const response = await createKassa({ name: kassaName.trim() });

            if (response.status === 201) {
                console.log("Kassa created successfully:", response.data.kassa.id);
                navigate("/kassa-page/" + response.data.kassa.id);
                setShowKassaModal(false);
                setKassaName("");
                setError("");
            }
        } catch (error) {
            console.error("Error creating Kassa:", error);
            setError("errorCreatingKassa");
        } finally {
            setLoadingModal(false);
        }
    };

    const handleInputChange = (e) => {
        setKassaName(e.target.value);
        if (error) setError("");
    };


    return (<>

            <Modal
                title="addKassa"
                onClose={handleCancel}
                error={t(error)}
                footer={
                    <>
                        {loadingModal ? <Loader /> : null}
                        <section className="o-row o-row--gap-size_300 o-row--horizontal-align_end">
                            <CustomButton
                                title={t("cancel")}
                                onClick={handleCancel}
                                icon={closeIcon}
                                iconSize={15}
                                variant="blank"
                            />
                            <CustomButton
                                onClick={handleCreateKassa}
                                title={t("confirm")}
                                icon={saveIcon}
                                iconSize={18}
                                disabled={loadingModal}
                            />
                        </section>
                    </>
                }
            >
                {error ? (
                    <ErrorBox classList="o-row o-row--horizontal-align_end">
                        {t(error)}
                    </ErrorBox>
                ) : null}
                <section>
                    <div className="o-column o-column--gap-size_300">
                        <div className="edit-user-entity">
                            <CustomInput
                                name="kassaName"
                                value={kassaName}
                                onChange={handleInputChange}
                                errorText={error === "noKassaName" ? t(error) : null}
                                flex={true}
                                title={t("kassaName")}
                            />
                        </div>
                    </div>
                </section>
            </Modal>

    </>
    );
}

export default AddKassaModal;
